import { useNavigate } from 'react-router-dom'
import { useAppStore } from '../../store/useAppStore'
import { ENV } from '@shared/config/env'
import { ROUTES } from '@shared/config/routes'
import { logout, useAuthFlowStore } from '@features/web-auth'
import { Button } from '@shared/ui/Button'
import { ProfileLoginMethods } from '@widgets/profile-login-methods'
import { ProfileHeader } from './components'
import './ProfilePage.css'

/**
 * Кабинет (EU-сервис): профиль + email аккаунта + выход.
 * Без блока подписки, привязки карт и Telegram.
 */
const ProfilePage = () => {
  const { user, profile, clearAuth } = useAppStore()
  const navigate = useNavigate()

  const headerUser = ENV.IS_WEB && profile
    ? {
        id: profile.user_id,
        first_name: profile.name || '',
        last_name: '',
        username: '',
        language_code: 'en',
        photo_url: ''
      }
    : user

  const handleLogout = async () => {
    try { await logout() } catch { /* ignore */ }
    clearAuth()
    // Сбрасываем флоу авторизации: step персистится в sessionStorage,
    // иначе после выхода /auth откроется на старом шаге.
    useAuthFlowStore.getState().reset()
    navigate(ROUTES.AUTH, { replace: true })
  }

  return (
    <div className="profile-page">
      <ProfileHeader user={headerUser} />

      <ProfileLoginMethods />

      <div className="profile-page__logout">
        <Button variant="secondary" onClick={handleLogout} block>Log out</Button>
      </div>
    </div>
  )
}

export default ProfilePage
